import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { getRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { UserPassDetail } from '~types/subscription.type';

/**
 * The pass, its card, and every period behind it — newest period first.
 */
export const useQueryGetUserPassDetail = (
  passId: string | null | undefined,
  options?: Omit<
    UseQueryOptions<
      UserPassDetail,
      AxiosError<Record<string, string>>,
      UserPassDetail,
      (QUERY_KEY | string)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getUserPassDetail = (): Promise<UserPassDetail> =>
    getRequest({
      path: 'api/user-pass/detail',
      params: { id: passId },
    });

  return useQuery(
    [QUERY_KEY.GET_USER_PASS_DETAIL, passId ?? ''],
    () => getUserPassDetail(),
    {
      enabled: !!passId && !!inMemoryJWTService.getCurrentToken(),
      ...options,
    },
  );
};
